
import { call, put, takeLatest } from "redux-saga/effects";
import {
  addPatientFailure,
  addPatientSuccess,
  deletePatientFailure,
  deletePatientSuccess,
  fetchAdmissionPatientsFailure,
  fetchAdmissionPatientsSuccess,
  fetchAllPatientsFailure,
  fetchAllPatientsSuccess,
  fetchHistoryPatientsFailure,
  fetchHistoryPatientsSuccess,
  fetchPatientFailure,
  fetchPatientsFailure,
  fetchPatientsSuccess,
  fetchPatientSuccess,
  updatePatientFailure,
  updatePatientSuccess,
} from "./patientAction";
import {
  addPatientEffect,
  admissionPatientEffect,
  deletePatientEffect,
  editPatientEffect,
  historyPatientEffect,
  listPatient,
  listPatientEffect,
  ViewPatientEffect,
} from "./patientEffect";
import {
  ADD_PATIENT_REQUEST,
  DELETE_PATIENT_REQUEST,
  FETCH_ADMISSION_PATIENTS_REQUEST,
  FETCH_ALL_LIST_PATIENTS_REQUEST,
  FETCH_LIST_PATIENTS_REQUEST,
  FETCH_PATIENT_REQUEST,
  HISTORY_PATIENTS_REQUEST,
  UPDATE_PATIENT_REQUEST,
} from "./patientType";

function* fetchPatientsSaga(action) {

  try {
    const response = yield call(listPatientEffect, action.payload);
    yield put(fetchPatientsSuccess(response.data));
  } catch (error) {
    yield put(fetchPatientsFailure(error.message));
  }
}
function* fetchAllPatientsSaga(action) {

  try {
    const response = yield call(listPatient, action.payload);
    yield put(fetchAllPatientsSuccess(response.data));
  } catch (error) {
    yield put(fetchAllPatientsFailure(error.message));
  }
}

function* fetchAdmissionPatientsSaga(action) {
  try {
    const response = yield call(admissionPatientEffect, action.payload);
    yield put(fetchAdmissionPatientsSuccess(response.data));
  } catch (error) {
    yield put(fetchAdmissionPatientsFailure(error.message));
  }
}


function* fetchGHistoryPatientsSaga(action) {
  try {
    const response = yield call(historyPatientEffect, action.payload);
    yield put(fetchHistoryPatientsSuccess(response.data));
  } catch (error) {
    yield put(fetchHistoryPatientsFailure(error.message));
  }
}
function* fetchPatientSaga(action) {
  try {
    const response = yield call(ViewPatientEffect, action.payload.patientId);
    
    yield put(fetchPatientSuccess(response.data));
  } catch (error) {
    yield put(fetchPatientFailure(error.message));
  }
}

function* addPatientSaga(action) {
  try {
    const response = yield call(addPatientEffect, action.payload.patientData);
    yield put(addPatientSuccess(response.data));
  } catch (error) {
 
    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(addPatientFailure(backendMessage || 'Failed to add patient'));
  }
}

function* updatePatientSaga(action) {
  try {
    const response = yield call(
      editPatientEffect,
      action.payload.patientId,
      action.payload.patientData
    );
    yield put(updatePatientSuccess(response.data));
  } catch (error) {

    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(updatePatientFailure(backendMessage|| 'Failed to Update patient'));
  }
}

function* deletePatientSaga(action) {
  try {
    yield call(deletePatientEffect, action.payload.patientId);
    yield put(deletePatientSuccess(action.payload.patientId));
  } catch (error) {
    yield put(deletePatientFailure(error.message));
  }
}

export function* PatientSagas() {
  yield takeLatest(FETCH_LIST_PATIENTS_REQUEST, fetchPatientsSaga);
  yield takeLatest(FETCH_PATIENT_REQUEST, fetchPatientSaga);
  yield takeLatest(ADD_PATIENT_REQUEST, addPatientSaga);
  yield takeLatest(UPDATE_PATIENT_REQUEST, updatePatientSaga);
  yield takeLatest(DELETE_PATIENT_REQUEST, deletePatientSaga);
  yield takeLatest(HISTORY_PATIENTS_REQUEST, fetchGHistoryPatientsSaga);
  yield takeLatest(FETCH_ALL_LIST_PATIENTS_REQUEST, fetchAllPatientsSaga);
  yield takeLatest(FETCH_ADMISSION_PATIENTS_REQUEST, fetchAdmissionPatientsSaga);
}
